import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import styles from './userDetails.module.scss';
import { Col, Form, Row } from 'react-bootstrap';
import * as yup from 'yup';
import { Formik } from 'formik';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomButton } from '../../../../shared/customButton';
import { CustomCheckBox } from '../../../../shared/customCheckBox';
import { CustomDropdown } from '../../../../shared/customDropdown';
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import { addNewUser,updateUser } from "../../../../../services/util/userManagement";

const UserDetails = (props) => {

    const
        dropValue = [
            {
                label: 'Admin',
                value: 0,
            },
            {
                label: 'Recruiter',
                value: 10,
            },
            {
                label: 'Reviewer',
                value: 20,
            },
        ]

    let [userRoleType,setUserRoleType] = useState();
    let [userPermissionsByRoleType, setUserPermissionsByRoleType] = useState([]);
    const [isSubmittedActionPending, setIsSubmittedActionPending] = useState(false);
    const [isEmailEditEnable, setIsEmailEditEnable] = useState(false);
    const [currentEmail, setCurrentEmail] = useState();
    const [isEmailCheckedConfirmation, setIsEmailCheckedConfirmation] = useState(false);

    //yup validations
    const schema = yup.object({
        userEmail: yup.string().trim().email('Invalid email').matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        userRole: yup.number().required('Required'),
    });

    const submitDetails = async (values) => {
        setIsSubmittedActionPending(true);

        let results= {}
        if(props.isCreateMode){
            results = await addNewUser(
                values.userEmail,
                values.userRole
            );

            if (results.success === true) {
                ReactGA.event('new_user_added');
            }
        }
        else{
            results = await updateUser(
                props.userDetails.userID,
                values.userEmail,
                values.userRole
            );
        }

        if (results.success === true) {
            setIsSubmittedActionPending(false);
            props.reloadUsers();
            props.handleClose();
        } else {
            setIsSubmittedActionPending(false);
        }

    };

    const captureUserRoleType = (type) => {
        setUserRoleType(type);
        if(type==0){
            setUserPermissionsByRoleType(props.userRolePermissions?.admin)
        }
        else if(type==10){
            setUserPermissionsByRoleType(props.userRolePermissions?.recruiter)
        }
        else if(type==20){
            setUserPermissionsByRoleType(props.userRolePermissions?.reviewer)
        }
    }

    useEffect(() => {
        captureUserRoleType(props.userDetails.userRole);
        ReactGA.initialize([{
            trackingId: `${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`
        }]);
    }, []);

    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => submitDetails(values)}
                initialValues={{ userEmail: props.userDetails.email ? props.userDetails.email :'', userRole: (props.userDetails.userRole>=0) ? props.userDetails.userRole :'' }}
            >
                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount,
                    setFieldValue
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row className='mb-0'>
                            <Col className={styles.modalInputRow}>
                                <div className={styles.customTextEdit}>
                                    <CustomTextField
                                        label="Email"
                                        controlId="adminPanel_manageUsers_addUsers_userDetails_userEmail_userEmailFieldId"
                                        type="text"
                                        name="userEmail"
                                        placeholder="New user's email. ex:- anna@gmail.com"
                                        value={values.userEmail}
                                        handleOnChange={handleChange}
                                        errorMessage={errors.userEmail}
                                        validationMessageId="adminPanel_manageUsers_addUsers_userDetails_userEmailValidationMsgId"
                                        isInvalid={submitCount > 0 && !!errors.userEmail}
                                        disabled={!isEmailEditEnable && !props.isCreateMode}
                                    />
                                    {(!isEmailEditEnable && !props.isCreateMode) && (
                                        <span className={styles.editEmailIcon}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={() => {
                                                setCurrentEmail(values.userEmail);
                                                setIsEmailEditEnable(true)
                                            }}>
                                                <g clip-path="url(#clip0_4433_5016)">
                                                    <path d="M7.33325 2.66666H4.53325C3.41315 2.66666 2.85309 2.66666 2.42527 2.88464C2.04895 3.07639 1.74299 3.38235 1.55124 3.75867C1.33325 4.1865 1.33325 4.74655 1.33325 5.86666V11.4667C1.33325 12.5868 1.33325 13.1468 1.55124 13.5746C1.74299 13.951 2.04895 14.2569 2.42527 14.4487C2.85309 14.6667 3.41315 14.6667 4.53325 14.6667H10.1333C11.2534 14.6667 11.8134 14.6667 12.2412 14.4487C12.6176 14.2569 12.9235 13.951 13.1153 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.33323 10.6667H6.4496C6.77572 10.6667 6.93878 10.6667 7.09223 10.6298C7.22828 10.5972 7.35834 10.5433 7.47763 10.4702C7.61219 10.3877 7.72749 10.2724 7.95809 10.0418L14.3333 3.66666C14.8855 3.11437 14.8855 2.21894 14.3333 1.66666C13.781 1.11437 12.8855 1.11437 12.3333 1.66665L5.95808 8.04182C5.72747 8.27242 5.61217 8.38772 5.52971 8.52228C5.45661 8.64157 5.40274 8.77163 5.37007 8.90768C5.33323 9.06113 5.33323 9.22419 5.33323 9.55031V10.6667Z" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4433_5016">
                                                        <rect width="16" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                    )}
                                    {(isEmailEditEnable && !props.isCreateMode) && (
                                        <span className={styles.editCancleIcon}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                onClick={() => {
                                                    setFieldValue('userEmail', props.userDetails.email);
                                                    setCurrentEmail(null);
                                                    setIsEmailCheckedConfirmation(false);
                                                    setIsEmailEditEnable(false);
                                                }}
                                            >
                                                <path d="M15 5L5 15M5 5L15 15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={styles.modalUserRoleInputRow}>
                                <CustomDropdown
                                    label="User Role"
                                    controlId="adminPanel_manageUsers_addUsers_userDetails_userRoleDropdownId"
                                    name="userRole"
                                    value={values.userRole}
                                    handleOnChange={(e) => { setFieldValue('userRole', parseInt(e.target.value)); captureUserRoleType(parseInt(e.target.value)) }}
                                    dropdownValues={dropValue}
                                    errorMessage={errors.userRole}
                                    validationMessageId="adminPanel_manageUsers_addUsers_userDetails_userRoleValidationMsgId"
                                    isInvalid={submitCount > 0 && !!errors.userRole}
                                    hiddenOption="Select User Role"
                                />
                            </Col>

                        </Row>
                        {<Row id="adminPanel_manageUsers_addUsers_userDetails_inviteUserPermisionListSectionId">
                                <div>
                                    {userRoleType ==0 &&  <p className={styles.permissionTypeInfo}>Has all the permissions (including company settings, billing)</p>}
                                    {userRoleType ==10 && <p className={styles.permissionTypeInfo}>Has all the other permissions except company settings, manage users, delete candidate and billing</p>}
                                    {userRoleType ==20 && <p className={styles.permissionTypeInfo}>Limited permissions. Review candidate capabilities only</p>}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(0, 3).map((permissions, i) => (
                                        <p key={i} className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel} >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(3, 6).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(6, 9).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(9, 13).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div className={styles.permissionRowDiv}>
                                    {userPermissionsByRoleType.slice(13, 15).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(15, 17).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(17, 20).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(20, 23).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                            </Row>
                        }
                            {/*Current email and new email*/}
                        <Row>
                            {
                               (isEmailEditEnable && currentEmail !== values.userEmail) && (
                                    <div>
                                        <br />
                                        <Col className={styles.dividerRow}>
                                            <hr />
                                        </Col>
                                        <CustomAlertBox
                                            alertBodyText="Changing the current email address to a new email address"
                                            alertType="defaultAlert"
                                        />
                                        
                                        <p className='mt-3'>
                                            <span className={styles.editEmailDetails}>Current Email :</span>
                                            <span className={styles.editEmailSecDetails}>
                                                {currentEmail}
                                            </span>
                                        </p>
                                        <p>
                                            <span className={styles.editEmailDetails}>New Email &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</span>
                                            <span className={styles.editEmailSecDetails}>
                                                {values.userEmail}
                                            </span>
                                        </p>
                                        <CustomCheckBox

                                            id="emailCheckbox"
                                            label="I understand that after changing the email address, All tasks are handled by the newly added email address."
                                            controlId="emailCheckbox"
                                            name="emailCheckbox"
                                            handleOnChange={(event) => setIsEmailCheckedConfirmation(event.target.checked)}
                                            type="defaultCheckBoxLight"
                                            disabled={currentEmail === values.userEmail ? true : false}
                                        />
                                    </div>
                                    
                                )
                            }
                        </Row>

                        <Row className='ps-2 pe-2'  >
                            <Col className={styles.dividerRow}>
                                <hr />
                            </Col>
                        </Row>
                        
                        <Row >
                            <div className={styles.actionBtnRow}>                     
                            <div className='submitCancleBtn'>
                                <div >
                                    {props.isCreateMode &&
                                        <CustomButton
                                            id="adminPanel_manageUsers_addUsers_userDetails_inviteUserSendInvitationBtnId"
                                            buttonType="submit"
                                            label="Send Invitation"
                                            type="primaryBtn"
                                            backicon={
                                                isSubmittedActionPending === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                    : ''
                                            }
                                            disabled={isSubmittedActionPending === true ? true : false}
                                        />
                                    }
                                    {!props.isCreateMode &&
                                        <CustomButton
                                            id="adminPanel_manageUsers_addUsers_userDetails_userDetailsSubmitBtnId"
                                            buttonType="submit"
                                            label="Save User"
                                            type="primaryBtn"
                                            backicon={
                                                isSubmittedActionPending ? (
                                                    !isEmailCheckedConfirmation ? null : (<i className="fas fa-circle-notch fa-spin"></i>)
                                                ) : null
                                            }
                                            disabled={isSubmittedActionPending || (isEmailCheckedConfirmation === false && props.userDetails.email === currentEmail)}
                                        />
                                    }
                                </div>
                            </div>
                            {
                                isEmailEditEnable && (
                                    <div className={styles.submitCancleBtn}>
                                        <CustomButton
                                            label="Cancel"
                                            type="defaultBtn"
                                            handleClick={() => {
                                                setIsEmailEditEnable(props.handleClose)
                                            }}>
                                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.5 4.5L4.5 13.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M4.5 4.5L13.5 13.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </CustomButton>
                                    </div>
                                )
                            }
                            </div> 
                        </Row>
                    </Form>
                )}
            </Formik>
        </div >
    )
}
export default UserDetails;
